export default {
  update: 'currentNotificationsUpdate'
}
